/*
 * ANANDA Cart Gate — order-minimum (4 units) + 18+/terms confirmation, plus
 * two-way sync between the cart DRAWER and the /cart PAGE.
 * Loaded ONCE, globally, via ananda-fx.liquid (NOT inside the cart snippet,
 * which Dawn re-renders via innerHTML so inline scripts never run).
 *
 * Source of truth: this script. On every cart change (PUB_SUB cartUpdate) it
 * reads the real item_count from /cart.js and updates BOTH surfaces identically:
 *   - the red "add N more" nudge (incl. the live N)
 *   - the "מינימום 4 יח' במשלוח" banner line
 *   - the checkout button (disabled + data-ananda-min-met flag)
 *   - the accelerated-checkout buttons (.ananda-age-locked)
 *   - the 4 discount-progress meters (snippets/ananda-cart-meter.liquid)
 * The two gates are INDEPENDENT: checkout is enabled only when the 18+/terms box
 * is ticked AND the cart holds >= 4 units (either one failing blocks).
 *
 * Why JS and not just Liquid: on the /cart page Dawn only re-renders the
 * `.js-contents` region on a quantity change, and our gate markup lives OUTSIDE
 * it. And Dawn refreshes only the surface that originated a change (a qty/remove
 * on the page leaves the header drawer stale, and vice-versa) — both use the
 * same cartUpdate `source:'cart-items'`, so the event can't tell them apart.
 * We track which surface the shopper last edited (capture-phase listener, before
 * Dawn's own handlers) and refresh the OTHER one, in both directions.
 *
 * The checkbox markup + all related CSS live in snippets/ananda-cart-age.liquid;
 * the gate markup lives in cart-drawer.liquid / main-cart-footer.liquid. Server
 * render produces the correct first paint (no-JS fallback); this keeps it live.
 */
(function () {
  if (window.__anandaCartAgeInit) return;
  window.__anandaCartAgeInit = true;

  var MIN_UNITS = 4;
  var lastCount = null;
  var lastSurface = null; // 'page' | 'drawer' — which surface the shopper last edited

  function qsa(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }
  function cartUrl() { return (window.routes && routes.cart_url) ? routes.cart_url : '/cart'; }

  function anyChecked() {
    return qsa('[data-ananda-cart-age-cb]').some(function (cb) { return cb.checked; });
  }

  // Apply the full gate state for a known unit count, across BOTH surfaces.
  function gate(count) {
    if (typeof count !== 'number') return;
    lastCount = count;
    renderMeters(count);
    var confirmed = anyChecked();
    var minMet = count >= MIN_UNITS;
    var empty = count <= 0;

    qsa('[data-ananda-banner-min]').forEach(function (el) {
      el.hidden = minMet || empty;
    });

    qsa('[data-ananda-min-msg]').forEach(function (el) {
      el.hidden = minMet || empty;
      var n = el.querySelector('[data-ananda-min-remaining]');
      if (n) n.textContent = Math.max(0, MIN_UNITS - count);
    });

    qsa('button[name="checkout"]').forEach(function (b) {
      b.setAttribute('data-ananda-min-met', minMet ? 'true' : 'false');
      b.disabled = empty || !(confirmed && minMet);
    });

    qsa('.cart__dynamic-checkout-buttons, .additional-checkout-buttons').forEach(function (c) {
      c.classList.toggle('ananda-age-locked', !(confirmed && minMet));
    });
  }

  // Monotonic token: rapid edits fire parallel /cart.js fetches and HTTP does
  // not guarantee arrival order — a stale count landing LAST used to win and
  // freeze the gate + meters wrong (e.g. checkout left disabled at 4 units).
  // Only the newest request's response may drive the gate.
  var fetchSeq = 0;
  function fetchCount(cb) {
    var id = ++fetchSeq;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (id === fetchSeq) cb(c.item_count); })
      .catch(function () {});
  }

  // Re-render the cart DRAWER (used when the change happened on the /cart page).
  // Dawn's own onCartUpdate fetches ?section_id=cart-drawer and swaps the items +
  // .cart-drawer__footer; then re-apply the gate to the parts it doesn't touch.
  function refreshDrawerSurface() {
    var di = document.querySelector('cart-drawer-items');
    if (!di || typeof di.onCartUpdate !== 'function') return;
    var p = di.onCartUpdate();
    if (p && typeof p.then === 'function') p.then(function () { gate(lastCount); });
  }

  // Re-render the /cart PAGE (used when the change happened in the drawer). Dawn's
  // drawer update only renders cart-drawer + the icon bubble, leaving the page's
  // line items (incl. the quantity <input>) and the subtotal stale. cart-items'
  // own onCartUpdate refreshes the items section; the footer subtotal is a
  // separate section (main-cart-footer), so fetch + swap its .js-contents too.
  // gate() handles the banner / nudge / checkout button (outside .js-contents).
  function refreshPageSurface() {
    var ci = document.querySelector('cart-items');
    if (!ci) return;
    if (typeof ci.onCartUpdate === 'function') {
      var p = ci.onCartUpdate();
      if (p && typeof p.then === 'function') p.then(function () { gate(lastCount); });
    }
    fetch(cartUrl() + '?section_id=main-cart-footer')
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var src = doc.querySelector('#main-cart-footer .js-contents');
        var tgt = document.querySelector('#main-cart-footer .js-contents');
        if (src && tgt) tgt.innerHTML = src.innerHTML;
        gate(lastCount);
      })
      .catch(function () {});
  }

  function persist(confirmed) {
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'אישור גיל 18+': confirmed ? 'כן' : '' } })
      });
    } catch (e) {}
  }

  // Note which cart surface the shopper is editing, so after the change we can
  // refresh the OTHER one. Capture phase → runs before Dawn's own handlers.
  // 'change' covers the qty input + the +/- buttons (they dispatch change on the
  // input); 'click' covers the remove button (it calls updateQuantity directly,
  // with no change event).
  function noteSurface(e) {
    var el = e.target;
    if (!el || !el.closest) return;
    if (el.closest('cart-drawer-items')) lastSurface = 'drawer';
    else if (el.closest('cart-items')) lastSurface = 'page';
  }
  document.addEventListener('change', noteSurface, true);
  document.addEventListener('click', noteSurface, true);

  // Ticking/unticking the confirmation: mirror across surfaces, re-gate, persist.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-ananda-cart-age-cb]')) return;
    var confirmed = t.checked;
    qsa('[data-ananda-cart-age-cb]').forEach(function (cb) { cb.checked = confirmed; });
    // Instant feedback from the cached count, then ALWAYS re-verify against the
    // real cart. This is the user action that was left permanently locked when
    // lastCount went stale (Roi's checkout bug, 2026-08-29) — if any future path
    // ever mutates the cart without announcing it, the very next tick self-heals
    // within one round-trip instead of freezing until a refresh.
    if (lastCount !== null) gate(lastCount);
    fetchCount(gate);
    persist(confirmed);
  });

  // Any cart mutation. For source !== 'cart-items' (e.g. an add from a product
  // form) Dawn already cross-refreshes every surface, so we only re-gate. For
  // source === 'cart-items' (a qty/remove on the page OR in the drawer) Dawn
  // refreshed ONLY the originating surface — so we refresh the other one.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      // Drive the meter SYNCHRONOUSLY when the event carries the new count — a
      // +/- quantity change ships the full cart as event.cartData (source
      // 'cart-items', confirmed in Dawn's cart.js). gate() → renderMeters then
      // snaps to the OLD fill and animates to the NEW one in the SAME task as
      // Dawn's re-render, before any paint: the first painted frame is the old
      // fill and the bar sweeps ONCE, smoothly, to the new value. Deferring this
      // to the async /cart.js fetch below instead let the browser paint Dawn's
      // fresh new fill first and THEN jump back to animate — the "fill → empty a
      // little → fill" stutter Roi flagged (2026-07-14). The fetch stays as the
      // authoritative backstop (and covers adds, whose event carries no count).
      if (event && event.cartData && typeof event.cartData.item_count === 'number') {
        gate(event.cartData.item_count);
      }
      var fromCartSurface = !!(event && event.source === 'cart-items');
      var surface = lastSurface;
      lastSurface = null;
      fetchCount(function (count) {
        gate(count);
        if (!fromCartSurface) return;
        if (surface === 'drawer') refreshPageSurface();
        else if (surface === 'page') refreshDrawerSurface();
        else { refreshPageSurface(); refreshDrawerSurface(); } // origin unknown — sync both
      });
    });
  }

  // SAFETY NET for cart changes that never reach the pub-sub bus: Dawn repaints
  // the header cart bubble (a sections render) on EVERY cart mutation, whatever
  // code performed it — so a bubble mutation is a reliable "cart changed" signal
  // even for scripts/apps that skip publish(). The mix-box button used to be such
  // a path, which froze the checkout gate at a stale count (Roi, 2026-08-29); it
  // now publishes, and this observer covers anything else. Debounced; gate() is
  // idempotent for an unchanged count, so double-driving is harmless.
  var bubbleT;
  var bubble = document.getElementById('cart-icon-bubble');
  if (bubble && typeof MutationObserver === 'function') {
    new MutationObserver(function () {
      clearTimeout(bubbleT);
      bubbleT = setTimeout(function () { fetchCount(gate); }, 150);
    }).observe(bubble, { childList: true, subtree: true });
  }

  // Mobile back/forward cache: Safari/Chrome restore the page frozen as-left,
  // so lastCount (and possibly the whole cart UI) predates whatever the shopper
  // did on the page they're returning from. Re-sync the gate from the real cart;
  // if the count actually drifted, re-render both cart surfaces too.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    fetchCount(function (count) {
      var drifted = lastCount !== null && count !== lastCount;
      gate(count);
      if (drifted) { refreshDrawerSurface(); refreshPageSurface(); }
    });
  });

  // ---------- Confetti burst on the "משלוח חינם" banner line ----------
  // Ported from the ANANDA Floating Words section (confetti effect only, no bob):
  // a 4-brand-colour underline draws under the line then explodes into thin
  // streamer confetti. Fires on click of the line + auto when it first appears.
  var CC_COLORS = [
    'color-mix(in srgb, #E37A2C 68%, white)', // ALOHA
    'color-mix(in srgb, #1F6E4F 68%, white)', // GAIA
    'color-mix(in srgb, #B33640 68%, white)', // KYOTO
    'color-mix(in srgb, #1E5A99 68%, white)'  // SANTORINI
  ];
  function ccRemove() { if (this.parentNode) this.parentNode.removeChild(this); }
  function confettiBurst(host) {
    if (!host || host.querySelector('.ananda-cc-underline')) return; // one burst at a time
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var line = document.createElement('span');
    line.className = 'ananda-cc-underline';
    line.addEventListener('animationend', ccRemove);
    host.appendChild(line);
    var N = 28;
    for (var k = 0; k < N; k++) {
      var s = document.createElement('span');
      s.className = 'ananda-cc-piece';
      var oxFrac = (k + 0.5) / N + (Math.random() - 0.5) / N; // spread across the line width
      var ox = oxFrac * 100;
      var dir = (oxFrac - 0.5) * 2;                            // -1..+1 → fan outward
      var px = dir * (16 + Math.random() * 34) + (Math.random() * 16 - 8);
      var py = -(30 + Math.random() * 34);                     // up a bit
      var dx = px * 1.5 + (Math.random() * 20 - 10);
      var dy = py + 64 + Math.random() * 60;                   // gravity → fall & fade
      var w = 2.5 + Math.random() * 1.5;
      var h = 10 + Math.random() * 7;
      var r0 = 70 + Math.random() * 40;
      var r1 = r0 + (Math.random() * 2 - 1) * 150;
      var r2 = r1 + (Math.random() * 2 - 1) * 260;
      var dur = 0.95 + Math.random() * 0.6;
      var delay = 0.30 + Math.random() * 0.12;                 // launch as the line explodes
      s.style.cssText =
        '--ox:' + ox.toFixed(1) + '%;--c:' + CC_COLORS[k % 4] + ';' +
        '--w:' + w.toFixed(1) + 'px;--h:' + h.toFixed(1) + 'px;' +
        '--px:' + px.toFixed(1) + 'px;--py:' + py.toFixed(1) + 'px;' +
        '--dx:' + dx.toFixed(1) + 'px;--dy:' + dy.toFixed(1) + 'px;' +
        '--r0:' + r0.toFixed(0) + 'deg;--r1:' + r1.toFixed(0) + 'deg;--r2:' + r2.toFixed(0) + 'deg;' +
        '--dur:' + dur.toFixed(2) + 's;--delay:' + delay.toFixed(2) + 's;';
      s.addEventListener('animationend', ccRemove);
      host.appendChild(s);
    }
  }

  function setupConfetti() {
    // Click the line to (re)play.
    document.addEventListener('click', function (e) {
      var host = e.target && e.target.closest && e.target.closest('[data-ananda-confetti]');
      if (host) confettiBurst(host);
    });
    // Auto-burst when the drawer transitions into the open (.active) state.
    var drawerEl = document.querySelector('cart-drawer');
    if (drawerEl && typeof MutationObserver === 'function') {
      var wasActive = drawerEl.classList.contains('active');
      new MutationObserver(function () {
        var active = drawerEl.classList.contains('active');
        if (active && !wasActive) {
          var line = drawerEl.querySelector('[data-ananda-confetti]');
          if (line) confettiBurst(line);
          sweepMeters(drawerEl); // entrance sweep for the drawer's meters
        }
        wasActive = active;
      }).observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
    }
    // Auto-burst the /cart PAGE banner (visible immediately on load). The drawer's
    // own line is skipped here — it bursts on open via the observer above.
    qsa('[data-ananda-confetti]').forEach(function (l) {
      if (!l.closest('cart-drawer')) confettiBurst(l);
    });
  }

  // ---------- Discount-progress meter (snippets/ananda-cart-meter.liquid) ----------
  // A linear pricing clock: a sliding 4-unit window (4-8, 8-12, ... 20-24) whose
  // fill tracks the cart count. Tiers mirror the store's automatic discounts
  // (8->8% ... 24->24%), same table as the pricing clock. Rendered 4x (drawer
  // top/totals + /cart top/totals) — this engine drives ALL copies identically.
  //
  // Dawn re-renders cart markup via innerHTML, so a meter element may arrive
  // ALREADY at the new server state. Before animating we therefore SNAP every
  // meter back to the previous count's state (no transition), reflow, then
  // animate — the motion survives the re-render. Fresh elements swapped in
  // AFTER an animation (same count) are detected by the missing mSeen marker
  // and normalized instantly without cancelling a running animation.
  var METER_STEP = 4;
  var METER_CAP = 24;         // last discount tier — beyond it the meter shows "max"
  var METER_FILL_MS = 560;    // must track the CSS clip-path transition (0.55s)
  var METER_ROLL_MS = 300;    // must track the CSS odometer keyframes (0.3s)
  var meterCount = null;      // count the meters currently represent
  var meterSeq = 0;           // animation token — a newer pass cancels older async phases
  var meterReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function meterState(count) {
    var underMin = count < MIN_UNITS;
    var maxed = count >= METER_CAP;
    var winMin, winMax, fill, left, currentPct, nextPct, mode, badgeType, badgeText, messageHtml, labelMin, labelMax;

    if (underMin) {
      winMin = 0;
      winMax = MIN_UNITS; // 4
      fill = count / MIN_UNITS;
      left = Math.max(0, MIN_UNITS - count);
      currentPct = 0;
      nextPct = 0;
      mode = 'min';
      badgeType = 'min';
      badgeText = 'מינימום הזמנה: 4 יחידות';
      var uWord = left === 1 ? "פאוץ' 1" : left + " פאוצ'ים";
      messageHtml = 'מינימום הזמנה 4 יחידות · הוסיפו עוד <span class="ananda-meter-accent">' + uWord + '</span> להשלמת ההזמנה';
      labelMin = count + " יח'";
      labelMax = "4 יח' (מינימום)";
    } else if (count < 8) {
      winMin = MIN_UNITS; // 4
      winMax = 8;
      fill = (count - 4) / 4;
      left = 8 - count;
      currentPct = 0;
      nextPct = 8;
      mode = 'tier1';
      badgeType = 'met';
      badgeText = '✓ מינימום הזמנה הושג';
      var uWord = left === 1 ? "פאוץ' 1" : left + " פאוצ'ים";
      messageHtml = 'עוד <span class="ananda-meter-accent">' + uWord + '</span> לקבלת <span class="ananda-meter-bold"><span class="ananda-meter-ltr">8%</span> הנחה!</span>';
      labelMin = count + " יח'";
      labelMax = "8 יח' (8% הנחה)";
    } else if (maxed) {
      winMin = METER_CAP - METER_STEP; // 20
      winMax = METER_CAP; // 24
      fill = 1;
      left = 0;
      currentPct = METER_CAP; // 24
      nextPct = METER_CAP;
      mode = 'max';
      badgeType = 'unlocked';
      badgeText = 'הגעתם להנחה המקסימלית — 24% הנחה!';
      messageHtml = 'הגעתם להנחה המקסימלית — <span class="ananda-meter-bold"><span class="ananda-meter-ltr">24%</span> הנחה!</span>';
      labelMin = "24 יח' (24%)";
      labelMax = "24 יח' (24%)";
    } else {
      winMin = Math.floor(count / METER_STEP) * METER_STEP;
      if (winMin > METER_CAP - METER_STEP) winMin = METER_CAP - METER_STEP;
      winMax = winMin + METER_STEP;
      fill = (count - winMin) / METER_STEP;
      left = winMax - count;
      currentPct = count;
      nextPct = count + 1;
      mode = 'disc';
      badgeType = 'unlocked';
      badgeText = 'פתחתם ' + currentPct + '% הנחה!';
      messageHtml = 'עוד <span class="ananda-meter-accent">פאוץ\' 1</span> ובמקום <span class="ananda-meter-ltr ananda-meter-bold">' + currentPct + '%</span> תקבל <span class="ananda-meter-accent"><span class="ananda-meter-ltr ananda-meter-bold">' + nextPct + '%</span> הנחה</span>';
      labelMin = count + " יח' (" + currentPct + "%)";
      labelMax = winMax + " יח' (" + winMax + "%)";
    }

    if (fill < 0) fill = 0;
    if (fill > 1) fill = 1;

    return {
      count: count,
      winMin: winMin,
      winMax: winMax,
      fill: fill,
      left: left,
      currentPct: currentPct,
      nextPct: nextPct,
      mode: mode,
      badgeType: badgeType,
      badgeText: badgeText,
      messageHtml: messageHtml,
      labelMin: labelMin,
      labelMax: labelMax,
      underMin: underMin,
      maxed: maxed
    };
  }

  // Position the fill (LTR — revealed from the LEFT; 0.55s CSS transition unless .is-snap).
  function meterFill(m, f) {
    var fill = m.querySelector('[data-ananda-meter-fill]');
    if (fill) fill.style.clipPath = 'inset(0 ' + (100 - f * 100) + '% 0 0)';
  }

  // Paint a full state instantly (labels, badges, message, fill).
  function meterApply(m, st) {
    m.dataset.mSeen = '1';
    meterFill(m, st.fill);

    var lblMin = m.querySelector('[data-ananda-meter-lbl-min]');
    if (lblMin) lblMin.textContent = st.labelMin;
    var lblMax = m.querySelector('[data-ananda-meter-lbl-max]');
    if (lblMax) lblMax.textContent = st.labelMax;

    var badge = m.querySelector('[data-ananda-meter-badge]');
    if (badge) {
      badge.className = 'ananda-meter-badge ananda-meter-badge--' + st.badgeType;
      var bText = badge.querySelector('[data-ananda-meter-badge-text]');
      if (bText) bText.textContent = st.badgeText;
      var bIcon = badge.querySelector('.ananda-meter-badge__icon');
      if (bIcon) bIcon.style.display = (st.badgeType === 'unlocked' ? 'inline-block' : 'none');
    }

    var msg = m.querySelector('[data-ananda-meter-msg]');
    if (msg) {
      if (msg.getAttribute('data-mode') !== st.mode) {
        msg.setAttribute('data-mode', st.mode);
        if (!meterReduce) {
          msg.classList.remove('is-swap');
          void msg.offsetWidth;
          msg.classList.add('is-swap');
        }
      }
      msg.innerHTML = st.messageHtml;
    }
  }

  function meterSnap(m, st) { // reposition with NO motion
    m.classList.add('is-snap');
    meterApply(m, st);
    void m.offsetWidth;
    m.classList.remove('is-snap');
  }

  // Tier-unlock celebration: ring pulse on the track + confetti on badge/msg
  function meterCelebrate(m) {
    if (meterReduce) return;
    var track = m.querySelector('.ananda-cart-meter__track');
    if (track) {
      track.classList.add('is-pulse');
      setTimeout(function () { track.classList.remove('is-pulse'); }, 520);
    }
    var badge = m.querySelector('[data-ananda-meter-badge]');
    var host = badge || m.querySelector('[data-ananda-meter-msg]');
    if (host && m.offsetParent) confettiBurst(host);
  }

  // Animate one meter from the previous count's state to the target.
  function meterAnimate(m, from, to, dir, seq) {
    m.__mSeq = seq;
    meterSnap(m, from); // fresh server markup may already sit at the target
    if (from.winMin === to.winMin) {
      meterFill(m, to.fill);
      meterApply(m, to);
      if (dir > 0 && to.currentPct >= 8 && from.currentPct < 8) {
        setTimeout(function () {
          if (seq !== m.__mSeq) return;
          meterCelebrate(m);
        }, METER_FILL_MS + 40);
      }
      return;
    }
    if (dir > 0) {
      // FORWARD tier cross
      meterFill(m, 1);
      setTimeout(function () {
        if (seq !== m.__mSeq) return;
        meterCelebrate(m);
        meterApply(m, to);
        meterFill(m, 0);
        setTimeout(function () {
          if (seq !== m.__mSeq) return;
          if (to.fill > 0) meterFill(m, to.fill);
        }, METER_FILL_MS + 40);
      }, METER_FILL_MS + 40);
      return;
    }
    // BACKWARD (item removed -> lower window)
    meterFill(m, 0);
    setTimeout(function () {
      if (seq !== m.__mSeq) return;
      meterApply(m, to);
      m.classList.add('is-snap');
      meterFill(m, 1);
      void m.offsetWidth;
      m.classList.remove('is-snap');
      setTimeout(function () {
        if (seq !== m.__mSeq) return;
        meterFill(m, to.fill);
      }, 60);
    }, METER_FILL_MS + 40);
  }

  // Drive every meter to `count`. Called from gate() on every cart change.
  function renderMeters(count) {
    var meters = qsa('[data-ananda-meter]');
    var prev = meterCount;
    meterCount = count;
    if (!meters.length) return;

    if (count <= 0) {
      var hs = ++meterSeq;
      meters.forEach(function (m) { m.hidden = true; m.__mSeq = hs; });
      return;
    }
    meters.forEach(function (m) { m.hidden = false; });

    var st = meterState(count);

    if (prev === count) {
      meters.forEach(function (m) { if (!m.dataset.mSeen) meterApply(m, st); });
      return;
    }
    if (prev === null || meterReduce) {
      var ss = ++meterSeq;
      meters.forEach(function (m) { m.__mSeq = ss; meterSnap(m, st); });
      return;
    }
    var seq = ++meterSeq;
    var from = meterState(prev);
    var dir = count > prev ? 1 : -1;
    meters.forEach(function (m) { meterAnimate(m, from, st, dir, seq); });
  }

  // Entrance sweep — the fill grows from the window edge to the current value
  function sweepMeters(scopeEl) {
    if (meterReduce || meterCount === null || meterCount <= 0) return;
    var st = meterState(meterCount);
    if (st.fill <= 0) return;
    var seq = ++meterSeq;
    qsa('[data-ananda-meter]').forEach(function (m) {
      if (scopeEl && !scopeEl.contains(m)) return;
      if (!scopeEl && m.closest('cart-drawer')) return; // page-only sweep
      m.__mSeq = seq;
      m.classList.add('is-snap');
      meterApply(m, st);
      meterFill(m, 0);
      void m.offsetWidth;
      m.classList.remove('is-snap');
      setTimeout(function () { if (seq === m.__mSeq) meterFill(m, st.fill); }, 200);
    });
  }

  function init() {
    // Only do work where a gate exists (the cart drawer is present on every page).
    if (!document.querySelector('[data-ananda-cart-age-cb], button[name="checkout"], [data-ananda-min-msg]')) {
      return;
    }
    // Mirror the saved confirmation onto every checkbox, then seed the gate from
    // the real count so the very first checkbox toggle has an accurate minimum.
    var confirmed = anyChecked();
    qsa('[data-ananda-cart-age-cb]').forEach(function (cb) { cb.checked = confirmed; });
    fetchCount(function (count) {
      gate(count);
      sweepMeters(null); // entrance sweep for the /cart page meters
    });
  }

  function boot() { init(); setupConfetti(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
}());
